import React, { useState, useRef, useLayoutEffect, useEffect, forwardRef } from "react";

import Add from '@mui/icons-material/Add';
import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import CommentIcon from '@mui/icons-material/Comment';
import DeleteOutline from '@mui/icons-material//DeleteOutline';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DragHandleIcon from '@mui/icons-material/DragHandle';

import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import HomeIcon from '@mui/icons-material/Home';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPage from '@mui/icons-material/LastPage';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import SchoolIcon from '@mui/icons-material/School';
import Search from '@mui/icons-material/Search';
import StarRateIcon from '@mui/icons-material/StarRate';
import ThumbUp from '@mui/icons-material/ThumbUp';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import ViewColumn from '@mui/icons-material/ViewColumn';

import Close from '@mui/icons-material/Close';


const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} style={{ color: "#1a76d2" }} />),
  AddOutline: forwardRef((props, ref) => <Add {...props} ref={ref} />),
  ArrowDropDownIcon: forwardRef((props, ref) => <ArrowDropDownIcon {...props} ref={ref} />),
  CastForEducationIcon: forwardRef((props, ref) => <CastForEducationIcon {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} style={{ color: "#008000" }} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} style={{ color: "#ff0000" }} />),
  Close: forwardRef((props, ref) => <Close {...props} ref={ref} style={{ color: "#000000" }} />),
  CommentIcon: forwardRef((props, ref) => <CommentIcon {...props} ref={ref} />),
  CloudDownloadIcon: forwardRef((props, ref) => <CloudDownloadIcon {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} style={{ color: "#ff0000" }} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  DragHandleIcon: forwardRef((props, ref) => <DragHandleIcon {...props} ref={ref}  style={{ color: "#1a76d2" }} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} style={{ color: "#1a76d2" }} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  HomeIcon: forwardRef((props, ref) => <HomeIcon {...props} ref={ref} />),
  InfoIcon: forwardRef((props, ref) => <InfoOutlined {...props} ref={ref} />),
  KeyboardArrowLeft: forwardRef((props, ref) => <KeyboardArrowLeft {...props} ref={ref} />),
  KeyboardArrowRight: forwardRef((props, ref) => <KeyboardArrowRight {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  MenuIcon: forwardRef((props, ref) => <MenuIcon {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  NotificationsActiveIcon: forwardRef((props, ref) => <NotificationsActiveIcon {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  PriorityHighIcon: forwardRef((props, ref) => <PriorityHighIcon {...props} ref={ref} style={{ color: "#ffa726" }} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  SchoolIcon: forwardRef((props, ref) => <SchoolIcon {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  StarRateIcon: forwardRef((props, ref) => <StarRateIcon {...props} ref={ref} style={{ color: "#ffa726" }} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ThumbUpIcon: forwardRef((props, ref) => <ThumbUp {...props} ref={ref} style={{ color: "#1a76d2" }} />),
  ThumbUpIconNC: forwardRef((props, ref) => <ThumbUp {...props} ref={ref} />),
  QuestionMarkRoundedIcon: forwardRef((props, ref) => <QuestionMarkRoundedIcon {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


export default tableIcons;